<template>
    <v-flex xs12 class="mt-5">
        <canvas id="customer" height="400" style="width: 100%"></canvas>
    </v-flex>
</template>

<script>
    import Chart from 'chart.js'

    export default {
        name: 'orderCustomer',
        props: ['dataCustomer'],
        mounted () {
            let ctx = document.getElementById('customer').getContext('2d')

            new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Клиенты'],
                    datasets: [
                        {
                            label: 'Авторизованные',
                            data: [this.dataCustomer.customers_registered],
                            backgroundColor: ['#009600'],
                        },
                        {
                            label: 'Без авторизация',
                            data: [this.dataCustomer.customers_unregistered],
                            backgroundColor: ['#008e94']
                        },
                    ]
                },
                options: {
                    responsive: true,
                    legend: {
                        position: 'bottom',
                    },
                    title: {
                        display: true,
                        text: 'Статистика заказов по клиентам'
                    }
                }
            })
        }
    }
</script>
